import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ScaffoldHeaderProps } from "./types";
import { CustomHeader } from "@repo/core/components/layout/CustomHeader";
import { VStack } from "@gluestack-ui/themed";

export const ScaffoldHeader = ({
  title,
  onBackPress,
  rightIcon,
  rightIconSize,
  bg,
  rightIconVariant,
  rightWebLabel,
  headerStyle,
  onPressRightIcon,
  mb,
  showBackButtonOnWeb
}: ScaffoldHeaderProps) => {
  const { back } = useNavigation();
  return (
    <VStack mb={mb} w="$full" zIndex={999}>
      <CustomHeader
        title={title || ""}
        onBackPress={onBackPress ?? back}
        showBackButtonOnWeb={showBackButtonOnWeb}
        rightIcon={rightIcon}
        rightIconSize={rightIconSize}
        rightIconVariant={rightIconVariant}
        rightWebLabel={rightWebLabel}
        headerStyle={headerStyle}
        bg={bg}
        onPressRightIcon={onPressRightIcon}
      />
    </VStack>
  );
};
